[
  {
    "id": 61,
    "documentId": "nde44qvc9geovk0agpb2rfha",
    "title": "Senior Mobile Application Developer at Azendo",
    "slug": "azendo",
    "company": "Azendo",
    "type": "full-time",
    "position": "Senior Mobile Application Developer",
    "startDate": "2026-02-01",
    "endDate": null,
    "industry": "technology",
    "location": "Bangkok, Thailand",
    "workMode": null,
    "description": "Driving the native rebuild of Ledoc, a facility management platform, on Android and iOS. Rebuilding the legacy Kotlin/XML Android app into Jetpack Compose and the Swift/UIKit iOS app into SwiftUI incrementally, while the existing apps stay live in production.",
    "summary": "Driving the incremental native rebuild of the Ledoc facility management app",
    "achievements": [
      "Rebuilding legacy Android (Kotlin/XML to Jetpack Compose) and iOS (Swift/UIKit to SwiftUI) apps incrementally, while the existing apps stay live in production",
      "Designed the multi-module clean architecture: MVVM, Hilt, and Coroutines/Flow on Android; SwiftUI with Swift Concurrency on iOS",
      "Introduced an AI-assisted, spec-driven workflow generating 60%+ of production code, doubling speed"
    ],
    "isFeatured": true,
    "createdAt": "2026-08-14T09:13:25.865Z",
    "updatedAt": "2026-08-14T09:13:25.865Z",
    "publishedAt": "2026-08-14T09:13:25.875Z",
    "categories": [],
    "skills": [],
    "projects": [],
    "certifications": [],
    "awards": [],
    "logo": null,
    "links": [
      {
        "id": 357,
        "label": "Azendo",
        "url": "https://azendo.co",
        "type": "company-profile",
        "showIcon": true,
        "isExternal": true,
        "description": "Azendo company website",
        "isVisible": true
      },
      {
        "id": 358,
        "label": "Ledoc Android",
        "url": "https://play.google.com/store/apps/details?id=dk.lekon.ledocv4",
        "type": "play-store",
        "showIcon": true,
        "isExternal": true,
        "description": "Ledoc Mobile for Android",
        "isVisible": true
      },
      {
        "id": 359,
        "label": "Ledoc iOS",
        "url": "https://apps.apple.com/dk/app/ledoc-mobile-4-0/id1466761848",
        "type": "app-store",
        "showIcon": true,
        "isExternal": true,
        "description": "Ledoc Mobile for iOS",
        "isVisible": true
      }
    ],
    "seo": null
  },
  {
    "id": 62,
    "documentId": "rpz42h8sp5z0dg9gg4058g06",
    "title": "Founder & CTO at PT Venragroup Teknologi Indonesia",
    "slug": "venragroup",
    "company": "PT Venragroup Teknologi Indonesia",
    "type": "full-time",
    "position": "Founder & CTO",
    "startDate": "2018-05-01",
    "endDate": "2022-06-30",
    "industry": "technology",
    "location": "Surabaya, Indonesia",
    "workMode": "on-site",
    "description": "Founded and ran a software consultancy for local SMEs, leading product development and delivery of client projects while building and mentoring a small cross-functional team.",
    "summary": "Founder and CTO of a software consultancy for local SMEs",
    "achievements": [
      "Grew revenue 15% QoQ while building and mentoring a small cross-functional development team",
      "Led product development and delivery of client projects",
      "Delivered the GESITS electric-motorcycle IoT display on Kotlin, C++, and Android Things",
      "Delivered the Dolen Aja e-commerce app on Flutter"
    ],
    "isFeatured": false,
    "createdAt": "2025-08-05T12:23:58.903Z",
    "updatedAt": "2026-08-14T09:13:27.195Z",
    "publishedAt": "2026-08-14T09:13:27.208Z",
    "categories": [
      {
        "id": 399,
        "name": "project-management"
      },
      {
        "id": 400,
        "name": "soft-skills"
      }
    ],
    "skills": [],
    "projects": [],
    "certifications": [],
    "awards": [],
    "logo": null,
    "links": [],
    "seo": null
  },
  {
    "id": 63,
    "documentId": "f97ywpe3bcd0pwtwham1y9kb",
    "title": "Technical Lead at Photon",
    "slug": "photon",
    "company": "Photon",
    "type": "full-time",
    "position": "Technical Lead",
    "startDate": "2023-11-01",
    "endDate": "2025-11-30",
    "industry": "technology",
    "location": "Jakarta, Indonesia",
    "workMode": "hybrid",
    "description": "Led a cross-region engineering team through the consolidation and rewrite of the Avis Budget Group global car rental suite: 8 apps (Avis and Budget, each on Android and iOS across NAM/APAC and EMEA), built natively and in Flutter, into one React Native codebase serving 15M+ users.",
    "summary": "Technical Lead for the Avis Budget Group suite rewrite, 8 apps into one React Native codebase",
    "achievements": [
      "Consolidated 8 native and Flutter apps (Avis and Budget, Android and iOS, NAM/APAC and EMEA) into a single React Native codebase",
      "Architected a modular, component-based system that sped up core-feature integration and let each region customize its apps without forking the codebase",
      "Delivered 18% faster app launch, 45% fewer crashes, and 60%+ higher code reuse",
      "Served 15M+ users across NAM/APAC and EMEA"
    ],
    "isFeatured": false,
    "createdAt": "2025-08-05T12:23:58.796Z",
    "updatedAt": "2026-08-14T09:16:45.394Z",
    "publishedAt": "2026-08-14T09:16:45.413Z",
    "categories": [
      {
        "id": 401,
        "name": "mobile-development"
      },
      {
        "id": 402,
        "name": "project-management"
      },
      {
        "id": 403,
        "name": "architecture"
      }
    ],
    "skills": [],
    "projects": [
      {
        "id": 95,
        "documentId": "r652mrf9bi8juh4v35d1nnev",
        "title": "Avis Budget Group Mobile App Rewrite",
        "slug": "avis-budget-group-mobile-app",
        "description": "Led the consolidation and rewrite of the Avis Budget Group global car rental suite: 8 apps (Avis and Budget, each on Android and iOS across NAM/APAC and EMEA), built natively and in Flutter, into one React Native codebase serving 15M+ users.",
        "summary": "8 apps consolidated into one React Native codebase for 15M+ users",
        "type": "work",
        "currentStatus": "completed",
        "startDate": "2023-11-01",
        "endDate": "2024-06-30",
        "achievements": "Consolidated 8 native and Flutter apps into a single React Native codebase. Delivered 18% faster app launch, 45% fewer crashes, and 60%+ higher code reuse. Served 15M+ users across NAM/APAC and EMEA.",
        "challenges": "Migrating 8 apps from native and Flutter stacks onto one React Native codebase. Letting each region customize its apps without forking that codebase. Coordinating a cross-region engineering team.",
        "learnings": "Large-scale mobile app consolidation, cross-platform development strategies, team leadership in complex projects, and performance optimization for enterprise applications.",
        "role": "Technical Lead",
        "teamSize": 8,
        "client": "Avis Budget Group",
        "isFeatured": true,
        "isPublic": true,
        "createdAt": "2025-08-05T12:23:58.582Z",
        "updatedAt": "2026-08-14T09:16:46.425Z",
        "publishedAt": "2026-08-14T09:16:46.436Z"
      }
    ],
    "certifications": [],
    "awards": [],
    "logo": null,
    "links": [
      {
        "id": 360,
        "label": "Photon Company Profile",
        "url": "https://www.linkedin.com/company/photon-interactive/",
        "type": "company-profile",
        "showIcon": true,
        "isExternal": true,
        "description": "Photon LinkedIn company page",
        "isVisible": true
      },
      {
        "id": 361,
        "label": "Avis NAM App",
        "url": "https://apps.apple.com/us/app/avis-car-rental/id308342527",
        "type": "app-store",
        "showIcon": true,
        "isExternal": true,
        "description": "North America app",
        "isVisible": true
      },
      {
        "id": 362,
        "label": "Avis APAC App",
        "url": "https://play.google.com/store/apps/details?id=com.avis.androidapp",
        "type": "play-store",
        "showIcon": true,
        "isExternal": true,
        "description": "Asia-Pacific app",
        "isVisible": true
      },
      {
        "id": 363,
        "label": "Avis EMEA App",
        "url": "https://apps.apple.com/gb/app/avis-car-hire/id883735332",
        "type": "app-store",
        "showIcon": true,
        "isExternal": true,
        "description": "Europe, Middle East, Africa app",
        "isVisible": true
      }
    ],
    "seo": null
  },
  {
    "id": 64,
    "documentId": "pptyvpungskztvspifmx53wu",
    "title": "Mobile Application Developer at Buuuk Pte Ltd",
    "slug": "buuuk",
    "company": "Buuuk Pte Ltd",
    "type": "full-time",
    "position": "Mobile Application Developer",
    "startDate": "2022-12-01",
    "endDate": "2023-10-31",
    "industry": "technology",
    "location": "Singapore, Singapore",
    "workMode": "on-site",
    "description": "Built the vOCC flight-operations Android app for Scoot Airline and StyleUp!, a Flutter uniform-ordering app for United Overseas Bank employees.",
    "summary": "Mobile developer for Scoot Airline flight operations and UOB employee uniform ordering",
    "achievements": [
      "Built the mission-critical vOCC flight-operations app on the classic Android stack (Kotlin, Fragments, XML views), with role-based workflows for pilots, ground staff, and ops managers",
      "Maintained a 99.8% crash-free session rate in production for daily flight operations",
      "Developed and launched StyleUp! on Flutter with Clean Architecture and BLoC state management, streamlining uniform ordering for 5,000+ bank employees across Southeast Asia",
      "Integrated Firebase for real-time order tracking and push notifications, cutting order errors by 25%"
    ],
    "isFeatured": false,
    "createdAt": "2025-08-05T12:23:58.827Z",
    "updatedAt": "2026-08-14T09:16:45.661Z",
    "publishedAt": "2026-08-14T09:16:45.677Z",
    "categories": [
      {
        "id": 404,
        "name": "mobile-development"
      },
      {
        "id": 405,
        "name": "web-development"
      }
    ],
    "skills": [],
    "projects": [
      {
        "id": 96,
        "documentId": "vnlp60hryap4p8twf5lggbm0",
        "title": "StyleUp - UOB Bank Clothing Ordering App",
        "slug": "styleup-uob-bank-clothing-app",
        "description": "Developed StyleUp!, a clothing ordering app for United Overseas Bank employees, streamlining uniform ordering across Southeast Asia.",
        "summary": "Mobile app for UOB bank employee clothing orders",
        "type": "work",
        "currentStatus": "completed",
        "startDate": "2023-01-01",
        "endDate": "2023-06-30",
        "achievements": "Developed and launched the Flutter app on Clean Architecture with BLoC state management, streamlining uniform ordering for 5,000+ bank employees across Southeast Asia. Integrated Firebase for real-time order tracking and push notifications, cutting order errors by 25%.",
        "challenges": "Integrating with bank's existing systems and ensuring security compliance. Managing inventory synchronization and order tracking.",
        "learnings": "Banking system integration, security compliance, inventory management, and enterprise mobile app development.",
        "role": "Mobile Developer",
        "teamSize": 4,
        "client": "UOB Bank",
        "isFeatured": true,
        "isPublic": true,
        "createdAt": "2025-08-05T12:23:58.644Z",
        "updatedAt": "2026-08-14T09:16:46.675Z",
        "publishedAt": "2026-08-14T09:16:46.687Z"
      },
      {
        "id": 97,
        "documentId": "czkiouvz2i2zrjv5gigoke25",
        "title": "vOCC - Scoot Airline Virtual Operation Control Center",
        "slug": "vocc-scoot-airline-control-center",
        "description": "Developed the Virtual Operation Control Center (vOCC), a mission-critical flight-operations Android app for Scoot Airline, with role-based workflows for pilots, ground staff, and ops managers.",
        "summary": "Flight-operations Android app for Scoot Airline",
        "type": "work",
        "currentStatus": "completed",
        "startDate": "2022-12-01",
        "endDate": "2023-03-31",
        "achievements": "Built on the classic Android stack (Kotlin, Fragments, XML views) with role-based workflows for pilots, ground staff, and ops managers. Maintained a 99.8% crash-free session rate in production for daily flight operations.",
        "challenges": "Ensuring high availability and reliability for critical airline operations. Implementing real-time data synchronization and monitoring.",
        "learnings": "Critical system development, real-time monitoring, airline operations, and high-availability mobile applications.",
        "role": "Mobile Developer",
        "teamSize": 3,
        "client": "Scoot Airline",
        "isFeatured": false,
        "isPublic": true,
        "createdAt": "2025-08-05T12:23:58.667Z",
        "updatedAt": "2026-08-14T09:16:46.924Z",
        "publishedAt": "2026-08-14T09:16:46.936Z"
      }
    ],
    "certifications": [],
    "awards": [],
    "logo": null,
    "links": [
      {
        "id": 364,
        "label": "Buuuk Company Profile",
        "url": "https://www.linkedin.com/company/buuuk-pte-ltd/mycompany/",
        "type": "company-profile",
        "showIcon": true,
        "isExternal": true,
        "description": "Buuuk Pte Ltd LinkedIn company page",
        "isVisible": true
      },
      {
        "id": 365,
        "label": "Style Up Android",
        "url": "https://play.google.com/store/apps/details?id=com.styleup.app",
        "type": "play-store",
        "showIcon": true,
        "isExternal": true,
        "description": "UOB clothing app for Android",
        "isVisible": true
      },
      {
        "id": 366,
        "label": "Style Up iOS",
        "url": "https://apps.apple.com/id/app/style-up/",
        "type": "app-store",
        "showIcon": true,
        "isExternal": true,
        "description": "UOB clothing app for iOS",
        "isVisible": true
      }
    ],
    "seo": null
  },
  {
    "id": 65,
    "documentId": "jlpalh02u2en8m4idfys07lj",
    "title": "Mobile Application Developer at Bank Rakyat Indonesia",
    "slug": "bri",
    "company": "PT Bank Rakyat Indonesia (Persero) Tbk",
    "type": "full-time",
    "position": "Mobile Application Developer",
    "startDate": "2022-07-01",
    "endDate": "2023-04-30",
    "industry": "banking-finance",
    "location": "Jakarta, Indonesia",
    "workMode": "hybrid",
    "description": "Developed Ceria, a personal loan app with 5M+ downloads for Indonesia's largest state-owned bank, migrating the legacy Java app to Flutter.",
    "summary": "Mobile developer for Ceria, the BRI personal loan app",
    "achievements": [
      "Migrated the legacy Java app to a modern Flutter codebase, accelerating new-feature delivery by 40%",
      "Designed a simple custom architecture with Provider state management that the bank's in-house team could easily maintain and extend",
      "Engineered frontend optimizations that removed redundant API and Firebase calls, saving ~IDR 3B per month in infrastructure costs",
      "Reached 5M+ downloads on the Play Store"
    ],
    "isFeatured": false,
    "createdAt": "2025-08-05T12:23:58.856Z",
    "updatedAt": "2026-08-14T09:16:45.920Z",
    "publishedAt": "2026-08-14T09:16:45.936Z",
    "categories": [
      {
        "id": 406,
        "name": "mobile-development"
      },
      {
        "id": 407,
        "name": "backend-development"
      }
    ],
    "skills": [],
    "projects": [
      {
        "id": 98,
        "documentId": "j40diyoq82j0vh8k672qddoj",
        "title": "BRI Ceria - Personal Loan App",
        "slug": "bri-ceria-personal-loan-app",
        "description": "Developed Ceria, a personal loan app with 5M+ downloads for Indonesia's largest state-owned bank, migrating the legacy Java app to Flutter.",
        "summary": "Personal loan app for Bank Rakyat Indonesia",
        "type": "work",
        "currentStatus": "completed",
        "startDate": "2022-07-01",
        "endDate": "2023-04-30",
        "achievements": "Migrated the legacy Java app to a modern Flutter codebase, accelerating new-feature delivery by 40%. Designed a simple custom architecture with Provider state management that the bank's in-house team could easily maintain and extend. Removed redundant API and Firebase calls, saving ~IDR 3B per month in infrastructure costs.",
        "challenges": "Large-scale app migration from Java to Flutter. Maintaining backward compatibility and ensuring smooth transition for existing users.",
        "learnings": "Large-scale app migration, performance optimization, cost reduction strategies, and banking app development.",
        "role": "Mobile Developer",
        "teamSize": 6,
        "client": "PT Bank Rakyat Indonesia (Persero) Tbk",
        "isFeatured": true,
        "isPublic": true,
        "createdAt": "2025-08-05T12:23:58.688Z",
        "updatedAt": "2026-08-14T09:16:47.177Z",
        "publishedAt": "2026-08-14T09:16:47.186Z"
      }
    ],
    "certifications": [],
    "awards": [],
    "logo": null,
    "links": [
      {
        "id": 367,
        "label": "BRI Company Profile",
        "url": "https://www.linkedin.com/company/pt-bank-rakyat-indonesia-persero-tbk/",
        "type": "company-profile",
        "showIcon": true,
        "isExternal": true,
        "description": "PT Bank Rakyat Indonesia LinkedIn company page",
        "isVisible": true
      },
      {
        "id": 368,
        "label": "BRI Ceria Android",
        "url": "https://play.google.com/store/apps/details?id=id.co.bri.ceria",
        "type": "play-store",
        "showIcon": true,
        "isExternal": true,
        "description": "Personal loan app for Android",
        "isVisible": true
      },
      {
        "id": 369,
        "label": "BRI Ceria iOS",
        "url": "https://apps.apple.com/id/app/bri-ceria/id1670051543",
        "type": "app-store",
        "showIcon": true,
        "isExternal": true,
        "description": "Personal loan app for iOS",
        "isVisible": true
      }
    ],
    "seo": null
  },
  {
    "id": 66,
    "documentId": "aijr8458a4juxhrwrcluqn6q",
    "title": "Fullstack Mobile Developer at PT Lakone Serasa Juara",
    "slug": "lakone",
    "company": "PT Lakone Serasa Juara",
    "type": "full-time",
    "position": "Fullstack Mobile Developer",
    "startDate": "2020-05-01",
    "endDate": "2021-06-30",
    "industry": "iot-manufacturing",
    "location": "Surabaya, Indonesia",
    "workMode": "on-site",
    "description": "Built the Lakone smart coffee roaster app and IoT device: a Flutter app that controls and monitors smart coffee roasters over Bluetooth Low Energy, paired with embedded C++ firmware on the device.",
    "summary": "Fullstack developer for the Lakone smart coffee roaster app and IoT device",
    "achievements": [
      "Built a Flutter app that controls and monitors smart coffee roasters over Bluetooth Low Energy",
      "Adopted by roasters across Indonesia",
      "Implemented a PID-style control loop in the embedded C++ firmware that keeps the roaster on target temperature curves",
      "Made roast profiles repeatable across sessions"
    ],
    "isFeatured": false,
    "createdAt": "2025-08-05T12:23:58.881Z",
    "updatedAt": "2026-08-14T09:16:46.172Z",
    "publishedAt": "2026-08-14T09:16:46.189Z",
    "categories": [
      {
        "id": 408,
        "name": "mobile-development"
      }
    ],
    "skills": [],
    "projects": [
      {
        "id": 94,
        "documentId": "dfu22s0cnr56h5btca6aisrn",
        "title": "Lakone Smart Coffee Roaster - IoT & Mobile App",
        "slug": "smart-coffee-roaster",
        "description": "Built the Lakone smart coffee roaster: a Flutter app that controls and monitors the roaster over Bluetooth Low Energy, paired with embedded C++ firmware running on the device.",
        "summary": "IoT coffee roaster with mobile control and monitoring",
        "type": "work",
        "currentStatus": "completed",
        "startDate": "2020-05-01",
        "endDate": "2021-06-30",
        "achievements": "Built a Flutter app that controls and monitors smart coffee roasters over Bluetooth Low Energy, adopted by roasters across Indonesia. Implemented a PID-style control loop in the embedded C++ firmware that keeps the roaster on target temperature curves, making roast profiles repeatable.",
        "challenges": "Keeping the roaster on target temperature curves over a Bluetooth Low Energy link, and making roast profiles repeatable across sessions.",
        "learnings": "IoT device development, cross-platform mobile development, real-time communication protocols, temperature control systems, and hardware-software integration.",
        "role": "Lead Developer & IoT Engineer",
        "teamSize": 3,
        "client": null,
        "isFeatured": true,
        "isPublic": true,
        "createdAt": "2025-08-05T12:23:58.771Z",
        "updatedAt": "2026-08-14T09:16:19.797Z",
        "publishedAt": "2026-08-14T09:16:19.814Z"
      }
    ],
    "certifications": [],
    "awards": [],
    "logo": null,
    "links": [
      {
        "id": 370,
        "label": "Lakone Coffee Website",
        "url": "https://lakonecoffee.com/",
        "type": "company-profile",
        "showIcon": true,
        "isExternal": true,
        "description": "PT Lakone Serasa Juara company website",
        "isVisible": true
      }
    ],
    "seo": null
  }
]
